import { createAction, props } from '@ngrx/store';
import { UpdateRouteProps } from '../../shared/models/update-route-props.model';

export const updateRouteAction = createAction(
    '[Route] Update Route',
    props<UpdateRouteProps>(),
);
